module.exports = __webpack_public_path__ + "img/app_marker.1c1bc670.svg";